import { Star, Quote, Users } from "lucide-react";

const Testimonials = () => {
  const testimonials = [
    {
      quote: "This extension has completely changed how I work. I save at least 30 minutes a day not hunting for bookmarks.",
      author: "Sarah K.",
      role: "Product Designer",
      company: "Figma",
      avatar: "SK",
    },
    {
      quote: "The keyboard shortcuts are a game-changer. I can launch my entire morning workflow with three keystrokes.",
      author: "Michael T.",
      role: "Software Engineer",
      company: "GitHub",
      avatar: "MT",
    },
    {
      quote: "Finally, a bookmark manager that actually makes sense. Clean, fast, and exactly what I needed.",
      author: "Emma L.",
      role: "Marketing Manager",
      company: "Notion",
      avatar: "EL",
    },
    {
      quote: "The workspace profiles feature is incredible. I switch between work and personal in one click.",
      author: "David R.",
      role: "Freelance Developer",
      company: "Self-employed",
      avatar: "DR",
    },
    {
      quote: "Health monitoring saved me multiple times when important sites went down. Worth every penny.",
      author: "Jessica M.",
      role: "Project Manager",
      company: "Asana",
      avatar: "JM",
    },
    {
      quote: "I tried every bookmark extension out there. Local Route is the only one I've stuck with for over a year.",
      author: "Alex P.",
      role: "UX Researcher",
      company: "Airbnb",
      avatar: "AP",
    }
  ];

  const stats = [
    { value: "10,000+", label: "Active Users" },
    { value: "4.9/5", label: "Average Rating" },
    { value: "500K+", label: "Shortcuts Created" },
  ];

  return (
    <section className="py-24 px-6 bg-muted/30">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-muted text-sm text-muted-foreground mb-4">
            <Users className="w-3.5 h-3.5" />
            User Reviews
          </div>
          <h2 className="text-3xl font-semibold mb-3">
            Loved by Thousands
          </h2>
          <p className="text-muted-foreground max-w-xl mx-auto">
            Join professionals who have transformed their daily workflow.
          </p>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-3 gap-4 mb-12 max-w-2xl mx-auto">
          {stats.map((stat, index) => (
            <div 
              key={stat.label} 
              className="text-center p-4 rounded-lg bg-card border border-border animate-fade-in"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className="text-2xl font-bold text-foreground">{stat.value}</div>
              <div className="text-xs text-muted-foreground">{stat.label}</div>
            </div>
          ))}
        </div>

        {/* Testimonials Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className="p-6 rounded-lg bg-card border border-border hover:border-foreground/20 hover:-translate-y-1 hover:shadow-lg transition-all duration-300 animate-fade-in"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <Quote className="w-8 h-8 text-muted-foreground/30 mb-4" />
              <div className="flex gap-1 mb-4">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} className="w-4 h-4 text-yellow-500 fill-yellow-500" />
                ))}
              </div>
              <p className="text-muted-foreground mb-6 leading-relaxed text-sm">"{testimonial.quote}"</p>
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full bg-gradient-to-br from-foreground/10 to-foreground/5 flex items-center justify-center text-sm font-medium">
                  {testimonial.avatar}
                </div>
                <div>
                  <p className="font-medium text-sm">{testimonial.author}</p>
                  <p className="text-xs text-muted-foreground">{testimonial.role} at {testimonial.company}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center mt-12">
          <a 
            href="https://gum.co/localroute-premium" 
            target="_blank" 
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-lg bg-foreground text-background font-medium hover:opacity-90 transition-opacity"
          >
            Join 10,000+ Happy Users
          </a>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
